import axios from "axios";
import messageBox from '@/commons/messageBox';
import commonFunction from "@/commons/commonFunction";
import {localStorageKeys} from '@/commons/storage-keys.ts'

let config = window._appConfig.configWithCredentials ? {
  withCredentials: true
} : {};

let api = axios.create({
    baseURL: window._apis['Business'],
    headers: {
    	'Content-Type': 'application/json',
      	'Access-Control-Allow-Origin': '*',
          'Authorization': `Bearer ${commonFunction.getAuthToken()}`
    },
    ...config
});

api.interceptors.response.use(
    response => response,
  error => {
    if (error && error.response && error.response.status == 401) {
      messageBox.showError('Phiên làm việc đã kết thúc.', '', 'MISA TaskGov').then(() => {
        commonFunction.logoff();
      });
    }
    return Promise.reject(error);
  }
);

export default api;